import React from "react";
import { jsx } from "react/jsx-runtime";
//#region src/contexts/PublishingContext.tsx
var PublishingContext = React.createContext(void 0);
function PublishingContextProvider({ children, footer, isPublishing, showGpsCoords = false, showInternalContent = false, title }) {
	return /* @__PURE__ */ jsx(PublishingContext.Provider, {
		value: {
			isPublishing: !!isPublishing,
			page: {
				footer,
				title
			},
			showGpsCoords,
			showInternalContent
		},
		children
	});
}
function usePublishingContext() {
	return React.useContext(PublishingContext);
}
function PublishVisibility({ children, visible }) {
	if (usePublishingContext()?.isPublishing && !visible) return null;
	return children;
}
function InternalOnlyPublishVisibility({ children, isInternal = true }) {
	const publishingCtx = usePublishingContext();
	if (publishingCtx && !publishingCtx?.showInternalContent && isInternal) return null;
	return children;
}
function GPSCoordsPublishVisibility({ children, forceVisibility }) {
	const publishingCtx = usePublishingContext();
	if (!forceVisibility && publishingCtx && !publishingCtx?.showGpsCoords && publishingCtx.isPublishing) return null;
	return children;
}
//#endregion
export { GPSCoordsPublishVisibility, InternalOnlyPublishVisibility, PublishVisibility, PublishingContextProvider, usePublishingContext };

//# sourceMappingURL=PublishingContext.js.map